import { useCallback } from 'react';

import { getCreatedResourceMessage } from 'src/data/performance';
import { useCustomerActions, useNotificationActions, usePerformanceActions } from 'src/store';

export const useExtractResource = () => {
  const customerActions = useCustomerActions();
  const performanceActions = usePerformanceActions();
  const notificationActions = useNotificationActions();

  return useCallback(
    async ({ name, url, tags, file, contentType }) => {
      performanceActions.setIsCreatingResource(true);

      const createdResource = await performanceActions.extractResource({
        name,
        url,
        tags,
        file,
        contentType,
      });
      customerActions.refreshCurrentCustomerFeatureLimit();
      performanceActions.queryWorkspaceResources();
      if (createdResource) {
        const message = getCreatedResourceMessage(createdResource);
        notificationActions.displaySuccess(message, null, { timeout: 5000 });
      }
      return createdResource;
    },
    [customerActions, performanceActions, notificationActions]
  );
};
